<div class="widget-wrapper-div pointer-events-none" [ngStyle]="marginBorderStyle">
  <div
    *ngFor="let item of widgetData?.linksList; let first = first; let last = last; let index = index"
    class="switch-navigator"
    [ngClass]="{
      border: !first && !last,
      'border-left': !first && widgetData?.linksList?.length === 2
    }"
    [ngStyle]="this.pageUrlsData[index]?.isActive ? activeSwitchStyle : contentStyle"
    (click)="redirectToPage(pageUrlsData[index])"
  >
    {{ item.textContent }}
  </div>
</div>
